var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "58.000000pt",
    viewBox: "0 0 200.000000 58.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,58.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1140 395 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557 403 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 315 l0 -85 31 0 c58 0 68 13 65 82 -2 56 -5 64 -26 75 -14 7 -35 13 -47 13 -22 0 -23 -3 -23 -85z m66 26 c-11 -18 -36 -13 -36 7 0 10 3 22 7 26 10 10 37 -20 29 -33z m2 -65 c-4 -31 -38 -34 -38 -3 0 29 7 37 27 30 8 -3 13 -15 11 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436 393 c-3 -3 -6 -41 -6 -84 0 -64 3 -77 14 -73 10 4 16 23 18 52 4 62 22 56 26 -9 4 -65 26 -61 30 5 4 53 -9 76 -38 69 -15 -4 -20 0 -20 15 0 22 -13 36 -24 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140 296 c0 -55 2 -64 15 -59 20 7 17 114 -2 121 -10 3 -13 -14 -13 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 340 c-37 -37 -18 -110 29 -110 27 0 41 21 41 61 0 35 -20 69 -41 69 -5 0 -18 -9 -29 -20z m43 -50 c0 -34 -7 -45 -22 -35 -12 7 -15 68 -4 78 12 12 26 -11 26 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338 352 c-28 -3 -28 -4 -28 -82 0 -66 2 -78 15 -74 8 4 15 12 15 20 0 8 8 14 18 14 29 0 42 21 42 67 0 47 -16 61 -62 55z m30 -62 c-5 -49 -28 -51 -28 -2 0 21 3 42 7 45 13 13 24 -11 21 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557 353 c-4 -3 -7 -30 -7 -60 0 -40 4 -53 15 -53 12 0 15 13 15 60 0 55 -6 70 -23 53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730 352 c-21 -7 -30 -23 -30 -55 0 -60 39 -87 75 -51 36 36 -1 122 -45 106z m30 -63 c0 -28 -4 -39 -15 -39 -11 0 -15 11 -15 38 0 21 3 42 6 45 14 13 24 -6 24 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1848 352 c-27 -3 -28 -5 -28 -63 0 -38 4 -58 10 -54 6 3 10 23 10 44 0 21 6 44 14 51 13 10 15 4 18 -39 4 -64 21 -67 28 -6 7 61 24 58 28 -4 2 -39 6 -49 18 -44 9 3 14 20 14 53 0 51 -16 75 -40 60 -8 -5 -21 -5 -29 -1 -9 4 -28 5 -43 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 290 c0 -47 3 -60 15 -60 11 0 15 12 15 44 0 36 4 46 20 51 32 10 23 25 -15 25 l-35 0 0 -60z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2a819804e0b9a390469d1aae7ef181b.svg";
export { ForwardRef as ReactComponent };